import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Avatar,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import axios from "axios";
import { InsertPhoto } from "@mui/icons-material";

const CompoundLogoDialog = ({
  open,
  onClose,
  initialLogo,
  userId,
  onUpdated,
}) => {
  const [preview, setPreview] = useState(initialLogo);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef();
  const [isSubmit, setIsSubmit] = useState(false);
  // ✅ Update preview when initialLogo or open changes
  useEffect(() => {
    if (open) {
      setPreview(initialLogo);
      setFile(null); // reset file on reopen
    }
  }, [initialLogo, open]);

  const handleFileSelect = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(selected);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", userId);
    setIsSubmit(true);
    try {
      let imageUrl;
      const uploadRes = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/upload/compound_logo`,
        formData
      );
      imageUrl = uploadRes.data;
      console.log(imageUrl);
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/compound/updateCompoundLogo`,
        {
          logo: imageUrl,
        }
      );
      onUpdated(imageUrl); // Pass new logo URL back to parent
      onClose();
    } catch (err) {
      console.error("Failed to upload logo", err);
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit compound logo</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary">
          Max. of 10MB. Recommended size: 840px x 840px
        </Typography>
        <Box display="flex" justifyContent="center" mt={2} mb={2}>
          <Avatar
            src={preview || "undefined"}
            alt="Compound Logo Preview"
            variant="rounded"
            sx={{ width: 200, height: 200 }}
          >
            {!preview && <InsertPhoto fontSize="large" sx={{ opacity: 0.4 }} />}
          </Avatar>
        </Box>
        <Box textAlign="center">
          <Button
            onClick={() => fileInputRef.current.click()}
            variant="text"
            color="primary"
          >
            Change picture
          </Button>
          <input
            type="file"
            accept="image/*"
            hidden
            ref={fileInputRef}
            onChange={handleFileSelect}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleUpload}
          disabled={!file || isSubmit}
          variant="contained"
          color="primary"
        >
          {isSubmit ? "saving ... " : "Set as logo"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompoundLogoDialog;
